// extracted by css-extract-rspack-plugin
export default {"metabaseLink":"NnfZr","light":"n_GUL","dark":"nG5UA"};